import { useEffect, useRef, useState } from "react";

import SpecialityFilters from "../SpecialityFilters";
// import TreatmentTabs from "../../TreatmentTabs";
import "./CSSResponsiveTabs.css";
import TabsComponentNotesLevel from "../../TabsComponentNotesLevel";

const SmartResponsiveTabsContainer = ({
  specialitiesList,
  activeSpecialty,
  onSpecialtyChange,
  HandlePage,
  tabsData,
  addTab,
  photoTab,
  setMaxWidth,
}) => {
  const containerRef = useRef(null);
  const specialtyRef = useRef(null);
  const viewRef = useRef(null);
  const photoRef = useRef(null);
  const addBtnsRef = useRef(null);
  const [hasInitialized, setHasInitialized] = useState(false);

  useEffect(() => {
    const measureAndSetBreakpoints = () => {
      if (!containerRef.current || !specialtyRef.current || !viewRef.current || hasInitialized) {
        return;
      }

      // Get actual widths
      const specialtyWidth = specialtyRef.current.offsetWidth;
      const viewWidth = viewRef.current.offsetWidth;
      const addBtnsWidth = addBtnsRef.current.offsetWidth;
      const minGap = 15;
      const photosRightMargin = 186;

      // Calculate breakpoints based on maintaining 15px gaps
      const largeBreakpoint =
        specialtyWidth +
        minGap +
        viewWidth +
        minGap +
        50 +
        addBtnsWidth +
        minGap +
        100 + //right side
        90 + // Photos tab with label width
        photosRightMargin;

      const mediumBreakpoint =
        specialtyWidth +
        minGap +
        200 + // Minimum compressed view tabs width
        minGap +
        80 + // Compressed add buttons width
        minGap +
        66 + // Photos tab icon only width
        photosRightMargin;

      const updateResponsiveClass = () => {
        if (!containerRef.current) return;

        const containerWidth = containerRef.current.offsetWidth;
        const container = containerRef.current;
        container.classList.remove("responsive-large", "responsive-medium", "responsive-small");

        if (containerWidth >= largeBreakpoint) {
          container.classList.add("responsive-large");
        } else if (containerWidth >= mediumBreakpoint) {
          container.classList.add("responsive-medium");
        } else {
          container.classList.add("responsive-small");
        }
      };

      updateResponsiveClass();

      const resizeObserver = new ResizeObserver(() => {
        updateResponsiveClass();
      });

      resizeObserver.observe(containerRef.current);
      setHasInitialized(true);

      return () => resizeObserver.disconnect();
    };

    const timeoutId = setTimeout(measureAndSetBreakpoints, 100);
    return () => clearTimeout(timeoutId);
  }, [specialitiesList.length, hasInitialized]);

  useEffect(() => {
    setHasInitialized(false);
  }, [specialitiesList.length]);

  return (
    <div
      ref={containerRef}
      className="smart-responsive-tabs-wrapper"
      style={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        height: "25px",
        // position: "relative",
        gap: "15px",
        justifyContent: "space-between",
        position: "sticky",
        top: "0px",
        zIndex: "10",
        background: "var(--primary-2)",
      }}
    >
      <div ref={specialtyRef} className="specialty-section">
        <SpecialityFilters
          specialitiesList={specialitiesList}
          activeSpecialty={activeSpecialty}
          onSpecialtyChange={onSpecialtyChange}
          setMaxWidth={setMaxWidth}
        />
      </div>

      <div
        ref={viewRef}
        className="view-tabs-section"
        style={{
          right: "50px",
        }}
      >
        <TabsComponentNotesLevel handlePage={HandlePage} tabsData={tabsData} height={25} />
      </div>

      <div
        ref={addBtnsRef}
        style={{
          right: "100px",
        }}
        className="add-tabs-section"
      >
        <TabsComponentNotesLevel handlePage={HandlePage} tabsData={addTab} height={25} />
      </div>

      <div ref={photoRef} className="photos-section">
        <TabsComponentNotesLevel
          labelClass="justify-content-end"
          handlePage={HandlePage}
          tabsData={photoTab}
          height={25}
        />
      </div>
    </div>
  );
};

export default SmartResponsiveTabsContainer;
